<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card class="mx-auto">
      <v-card-title class="primary white--text v-card-title">
        <v-icon left color="white">mdi-tag-plus</v-icon>
        Promoción
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrarModal" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="pt-6">
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-row>
            <!-- Folio -->
            <v-col cols="12" sm="7">
              <v-text-field
                v-model="promocion.folio"
                label="Folio"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="receipt"
              ></v-text-field>
            </v-col>
            
            <!-- Motivo de la prueba -->
            <v-col cols="12" sm="5">
              <v-text-field
                v-model="promocion.motivoPrueba"
                label="Motivo de la prueba"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="description"
              ></v-text-field>
            </v-col>

            <!-- Nombre -->
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="promocion.nombre"
                label="Nombre"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="person"
              ></v-text-field>
            </v-col>

            <!-- Apellido paterno -->
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="promocion.apellidoPaterno"
                label="Apellido paterno"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="person"
              ></v-text-field>
            </v-col>

            <!-- Apellido materno -->
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="promocion.apellidoMaterno"
                label="Apellido materno"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="person"
              ></v-text-field>
            </v-col>

            <!-- Fecha de nacimiento -->
            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFechaNacimiento"
                v-model="menuFechaNacimiento"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaNacimientoFormated"
                    label="Fecha de nacimiento"
                    prepend-icon="event"
                    readonly
                    outlined
                    required
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaNacimiento"
                  @input="menuFechaNacimiento = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>


            <!-- Género -->
            <v-col cols="12" sm="4">
              <v-select
                v-model="promocion.genero"
                :items="generos"
                label="Género"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="wc"
              ></v-select>
            </v-col>

            <!-- Correo del paciente -->
            <v-col cols="12" sm="5">
              <v-text-field
                v-model="promocion.correoPaciente"
                label="Correo del paciente"
                outlined
                required
                :rules="[rules.emailRequired]"
                prepend-inner-icon="email"
              ></v-text-field>
            </v-col>

            <!-- Médico -->
            <v-col cols="12" sm="7">
              <v-text-field
                v-model="promocion.medico"
                label="Médico"
                outlined
                prepend-inner-icon="local_hospital"
              ></v-text-field>
            </v-col>

            <!-- Correo de Médico -->
            <v-col cols="12" sm="5">
              <v-text-field
                v-model="promocion.correoMedico"
                label="Correo de Médico"
                outlined
                :rules="[rules.emailOptional]"
                prepend-inner-icon="email"
              ></v-text-field>
            </v-col>

            <!-- Fecha de Pago -->
            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFechaPago"
                v-model="menuFechaPago"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaPagoFormated"
                    label="Fecha de Solicitud"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaPago"
                  @input="menuFechaPago = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            
            <!-- Fecha de Toma -->
            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFechaToma"
                v-model="menuFechaToma"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaTomaFormated"
                    label="Fecha de Cita"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaToma"
                  @input="menuFechaToma = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Fecha de Muestra -->
            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFechaMuestra"
                v-model="menuFechaMuestra"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaMuestraFormated"
                    label="Fecha de Toma"
                    prepend-icon="event"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaMuestra"
                  @input="menuFechaMuestra = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Fecha de Recepción -->
            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFechaRecepcion"
                v-model="menuFechaRecepcion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaRecepcionFormated"
                    label="Fecha de Recepción"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaRecepcion"
                  @input="menuFechaRecepcion = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      
      <v-card-actions class="px-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          text
          @click="limpiarFormulario"
        >
          <v-icon left>clear</v-icon>
          Limpiar
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!validForm"
          @click="guardarPromocion"
          style="background-color: #21436A;"
        >
          <v-icon left>save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    
    <!-- Snackbar para mensajes -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.text }}
      <v-btn
        text
        @click="snackbar.show = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import ServicioRecepcionDAO from "../services/recepciondao";

export default {
  name: 'PromocionModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validForm: false,
      menuFechaPago: false,
      menuFechaToma: false,
      menuFechaMuestra: false,
      menuFechaRecepcion: false,
      menuFechaNacimiento: false,
      promocion: {
        folio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombre: '',
        fechaNacimiento: null,
        fechaNacimientoFormated: '',
        correoPaciente: '',
        motivoPrueba: '',
        genero: '',
        medico: '',
        correoMedico: '',
        fechaPago: null,
        fechaToma: null,
        fechaMuestra: null,
        fechaRecepcion: null,
        fechaPagoFormated: '',
        fechaTomaFormated: '',
        fechaMuestraFormated: '',
        fechaRecepcionFormated: ''
      },
      rules: {
        required: value => !!value || 'Este campo es requerido',
        emailOptional: value => !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Formato de correo inválido',
        emailRequired: value => (!!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) || 'Formato de correo inválido'
      },
      generos: ['MASCULINO', 'FEMENINO'],
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        timeout: 3000
      }
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    'promocion.fechaPago'(newVal) {
      if (newVal) {
        this.promocion.fechaPagoFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaToma'(newVal) {
      if (newVal) {
        this.promocion.fechaTomaFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaMuestra'(newVal) {
      if (newVal) {
        this.promocion.fechaMuestraFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaRecepcion'(newVal) {
      if (newVal) {
        this.promocion.fechaRecepcionFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaNacimiento'(newVal) {
      if (newVal) {
        this.promocion.fechaNacimientoFormated = this.formatDate(newVal);
      } else {
        this.promocion.fechaNacimientoFormated = '';
      }
    },
    dialog(newVal) {
      if (newVal) {
        console.log('Modal se está abriendo, inicializando...');

        // Limpiar campos inmediatamente cuando se abre
        this.promocion.folio = '';
        this.promocion.apellidoPaterno = '';
        this.promocion.apellidoMaterno = '';
        this.promocion.nombre = '';
        this.promocion.fechaNacimiento = null;
        this.promocion.fechaNacimientoFormated = '';
        this.promocion.correoPaciente = '';
        this.promocion.motivoPrueba = '';
        this.promocion.genero = '';
        this.promocion.medico = '';
        this.promocion.correoMedico = '';

        // Inicializar fechas con fecha actual
        this.initializeDates();
        
        // Resetear validaciones después de que el DOM esté listo
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
          console.log('Modal completamente inicializado');
        });
      }
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    initializeDates() {
      const today = this.getTodayDate();
      console.log('Inicializando fechas con:', today);

      // Asignar fechas sin formato para los date pickers
      this.promocion.fechaPago = today;
      this.promocion.fechaToma = today;
      this.promocion.fechaMuestra = today;
      this.promocion.fechaRecepcion = today;

      // Asignar fechas formateadas para mostrar en los campos de texto
      const formattedToday = this.formatDate(today);
      this.promocion.fechaPagoFormated = formattedToday;
      this.promocion.fechaTomaFormated = formattedToday;
      this.promocion.fechaMuestraFormated = formattedToday;
      this.promocion.fechaRecepcionFormated = formattedToday;
      
      console.log('Fechas inicializadas:', {
        fechaPago: this.promocion.fechaPago,
        fechaPagoFormated: this.promocion.fechaPagoFormated,
        fechaToma: this.promocion.fechaToma,
        fechaTomaFormated: this.promocion.fechaTomaFormated,
        fechaMuestra: this.promocion.fechaMuestra,
        fechaMuestraFormated: this.promocion.fechaMuestraFormated,
        fechaRecepcion: this.promocion.fechaRecepcion,
        fechaRecepcionFormated: this.promocion.fechaRecepcionFormated
      });
    },
    
    obtenerNombreCompleto() {
      const partes = [
        this.promocion.apellidoPaterno && this.promocion.apellidoPaterno.trim(),
        this.promocion.apellidoMaterno && this.promocion.apellidoMaterno.trim(),
        this.promocion.nombre && this.promocion.nombre.trim()
      ].filter(Boolean);

      return partes.join(' ');
    },

    convertirFechaAISO(fecha) {
      if (!fecha) {
        return null;
      }

      if (fecha instanceof Date) {
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const day = String(fecha.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      if (typeof fecha === 'string') {
        const trimmed = fecha.trim();

        if (trimmed.includes('/')) {
          const [day, month, year] = trimmed.split('/');
          if (day && month && year) {
            return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          }
        }

        if (trimmed.includes('-')) {
          return trimmed;
        }
      }

      return fecha;
    },
    
    limpiarFormulario() {
      // Solo limpiar campos de texto, las fechas se manejan en initializeDates
      this.promocion.folio = '';
      this.promocion.apellidoPaterno = '';
      this.promocion.apellidoMaterno = '';
      this.promocion.nombre = '';
      this.promocion.fechaNacimiento = null;
      this.promocion.fechaNacimientoFormated = '';
      this.promocion.correoPaciente = '';
      this.promocion.motivoPrueba = '';
      this.promocion.genero = '';
      this.promocion.medico = '';
      this.promocion.correoMedico = '';
      this.initializeDates();

      // Solo resetear validaciones, no el formulario completo
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    
    cerrarModal() {
      this.$emit('input', false);
    },
    
    async guardarPromocion() {
      if (this.$refs.form.validate()) {
        try {
          console.log('Guardando promoción:', this.promocion);

          const nombreCompleto = this.obtenerNombreCompleto();

          // Preparar datos para enviar al servicio
          const datosCrear = {
            transaction_id: this.promocion.folio,
            Paciente: nombreCompleto,
            Paterno: this.promocion.apellidoPaterno,
            Materno: this.promocion.apellidoMaterno,
            Nombre: this.promocion.nombre,
            FechaNacimiento: this.convertirFechaAISO(this.promocion.fechaNacimiento) || this.convertirFechaAISO(this.promocion.fechaNacimientoFormated),
            Email: this.promocion.correoPaciente,
            Causa: this.promocion.motivoPrueba,
            Genero: this.promocion.genero,
            FechaSolicitud: this.convertirFechaAISO(this.promocion.fechaPago) || this.convertirFechaAISO(this.promocion.fechaPagoFormated),
            FechaCita: this.convertirFechaAISO(this.promocion.fechaToma) || this.convertirFechaAISO(this.promocion.fechaTomaFormated),
            FechaMuestra: this.convertirFechaAISO(this.promocion.fechaMuestra) || this.convertirFechaAISO(this.promocion.fechaMuestraFormated),
            FechaRecepcion: this.convertirFechaAISO(this.promocion.fechaRecepcion) || this.convertirFechaAISO(this.promocion.fechaRecepcionFormated),
            Medico_Nombre: this.promocion.medico,
            Medico_Email: this.promocion.correoMedico
          };

          // Llamar al servicio para crear el registro
          const response = await ServicioRecepcionDAO.crear(datosCrear);

          if (response?.data?.result === 1) {
            //this.mostrarMensaje('Promoción guardada exitosamente', 'success');

            // Emitir evento con los datos de la promoción y el id del registro creado
            const idCreado = response.data?.data?.id || response.data?.id || Date.now();
            const promocionGuardada = {
              ...this.promocion,
              nombrePaciente: nombreCompleto,
              id: idCreado
            };

            this.$emit('promocionGuardada', promocionGuardada);

            setTimeout(() => {
              this.$emit('input', false);
            }, 1000);
          } else {
            this.mostrarMensaje('Error al guardar la promoción: ' + (response?.data?.mensaje || 'Error desconocido'), 'error');
          }

        } catch (error) {
          console.error('Error al guardar promoción:', error);
          this.mostrarMensaje('Error al guardar la promoción', 'error');
        }
      }
    },
    
    mostrarMensaje(texto, color = 'success') {
      this.snackbar.text = texto;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
.v-card-title {
  font-size: 1.05rem;
  font-weight: 500;
  background-color: #002855 !important;
}

.v-card-text {
  background-color: #fafafa;
}

.theme--light.v-btn.v-btn--has-bg.primary {
  background-color: #002855 !important;
  border-color: #002855 !important;
}

.theme--light.v-btn.v-btn--has-bg.primary:hover {
  background-color: #003a75 !important;
}

.primary {
  background-color: #21436A !important;
}
</style>
